
import styles from "./About.module.css"


export const AboutPage = () =>{


return(

<div className={styles.aboutdiv} name="about">

<h1 style={{"fontSize":"60px"}}>About</h1>

<h4 className={styles.about}>I have been doing FULL-TIME course with Masai School.There I am learning Data Structures and Algorithm, JavaScript,React etc.There I have been doing 1100+ hrs of coding.I have hands-on experience developing websites using front-end and back-end skills like React, Redux, Html, CSS, Nodejs, JavaScript, etc. Looking to further enhance Html, React, Redux, Nodejs, and Js skills as a future full stack developer</h4>

</div>




)



}